import {
  buildJobListingsUrl,
  buildJobListingUrl,
} from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler } from "./types";

const NearbyJobRecommendationsSchema = z.object({
  weekOf: z.string(),
  jobs: z
    .array(
      z.object({
        slug: z.string(),
        jobTitle: z.string(),
        workplaceName: z.string(),
        distanceKm: z.number().nonnegative(),
      })
    )
    .min(1)
    .max(3),
});

export const nearbyJobRecommendationsHandler = defineEmailNotificationHandler({
  type: "job.nearby_recommendations",
  icon: "application",
  title() {
    return "Jobs near you";
  },
  description(metadata) {
    const count = Array.isArray(metadata.jobs) ? metadata.jobs.length : 0;
    return `${count || "New"} open ${count === 1 ? "role is" : "roles are"} available near your saved location.`;
  },
  schema: NearbyJobRecommendationsSchema,
  buildNotificationPayload(data) {
    return {
      metadata: data,
      links: { href: "/job-listings", label: "View nearby jobs" },
      groupId: `nearby-jobs:${data.weekOf}`,
    };
  },
  buildEmailPayload(data, recipient, { baseUrl, unsubscribeUrl }) {
    return {
      name: "email/job.nearby_recommendations",
      data: {
        userId: recipient.userId,
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        jobs: data.jobs.map((job) => ({
          jobTitle: job.jobTitle,
          workplaceName: job.workplaceName,
          distanceKm: job.distanceKm,
          listingUrl: buildJobListingUrl({ baseUrl, slug: job.slug }),
        })),
        listingsUrl: buildJobListingsUrl(baseUrl),
        unsubscribeUrl,
      },
    };
  },
});
